module.exports = __webpack_public_path__ + "static/img/icon-enter-item6.6cf66c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-enter-item6.png
// module id = abwc
// module chunks = 21